module.exports = __webpack_public_path__ + "img/1441013720.01a6132b.jpg";